
import axios from "axios";
import { IP } from "utils/Host";


export function dropStageScalPrzerwy(przerwaId,proces_nazwa_id,refreshGantAll) {

// id = procesor id
console.log("dropStageScalPrzerwy")

if(parseInt(proces_nazwa_id)==6){
  axios
  .get(IP + "API_0012_gant_procedura_scal_przerwe_oprawa/"+przerwaId+"/"+ sessionStorage.getItem("token"))
    .then((res) => {
refreshGantAll()

    })

}else{
    axios
  .get(IP + "API_0007_gant_procedura_scal_przerwe/"+przerwaId+"/"+ sessionStorage.getItem("token"))
    .then((res) => {
refreshGantAll()

    })
}
  

}


